import { PersonChangeContainer } from "../containers/PersonChangeContainer";

export const ChangePersonPage = () => (
    <PersonChangeContainer type='change'/>
)